(()=>{
 if(customElements.get('cosy-product-hearts'))return;
 let cache=null,until=0,inflight=null;
 const policy=()=>{
  if(cache&&Date.now()<until)return Promise.resolve(cache);
  if(inflight)return inflight;
  inflight=fetch('/apps/cosy-herzen?resource=earning-preview',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}}).then(r=>{if(!r.ok)throw new Error('unavailable');return r.json();}).then(data=>{if(!('eligible' in data)||!('campaign' in data))throw new Error('invalid');cache=data;until=Date.now()+20000;return data;}).finally(()=>{inflight=null;});return inflight;
 };
 class CosyProductHearts extends HTMLElement{
  connectedCallback(){
   this.abort=new AbortController();const opts={signal:this.abort.signal};this.button=this.querySelector('button');this.panel=this.querySelector('.cosy-product-hearts__panel');if(!this.button||!this.panel)return;
   this.button.addEventListener('click',()=>{this.pinned=!this.pinned;this.open(this.pinned);},opts);
   this.addEventListener('mouseenter',()=>{if(matchMedia('(hover:hover)').matches)this.open(true);},opts);
   this.addEventListener('mouseleave',()=>{if(!this.pinned)this.open(false);},opts);
   this.addEventListener('focusin',()=>this.open(true),opts);
   this.addEventListener('focusout',e=>{if(!this.contains(e.relatedTarget)){this.pinned=false;this.open(false);}},opts);
   this.addEventListener('keydown',e=>{if(e.key==='Escape'){this.pinned=false;this.button.focus();this.open(false);}},opts);
   document.addEventListener('pointerdown',e=>{if(!this.contains(e.target)){this.pinned=false;this.open(false);}},opts);
   window.addEventListener('resize',()=>{if(!this.panel.hidden)this.open(true);},opts);
   this.productInfo=this.closest('product-info');
   const quantityChanged=e=>{if(e.target.matches('input[name="quantity"]'))this.update();};
   this.productInfo?.addEventListener('input',quantityChanged,opts);
   this.productInfo?.addEventListener('change',quantityChanged,opts);
   this.update();this.timer=setInterval(()=>{if(document.visibilityState==='visible')this.update();},30000);
  }
  disconnectedCallback(){this.abort?.abort();clearInterval(this.timer);}
  open(on){
   this.panel.hidden=!on;this.button.setAttribute('aria-expanded',String(on));if(!on)return;
   this.panel.style.transform='';this.panel.style.top='';this.panel.style.bottom='';this.panel.style.maxWidth='';
   let left=16,right=document.documentElement.clientWidth-16;
   const column=this.closest('.product__info-container');
   if(column){const bounds=column.getBoundingClientRect();left=Math.max(left,bounds.left);right=Math.min(right,bounds.right);}
   for(let parent=this.parentElement;parent;parent=parent.parentElement){
    const style=getComputedStyle(parent);if(/hidden|clip|auto|scroll/.test(style.overflowX)){
     const bounds=parent.getBoundingClientRect();left=Math.max(left,bounds.left+8);right=Math.min(right,bounds.right-8);
    }
   }
   this.panel.style.maxWidth=`${Math.max(0,right-left)}px`;
   const r=this.panel.getBoundingClientRect();
   if(r.bottom>innerHeight-(innerWidth<750?160:16)&&this.getBoundingClientRect().top>r.height+16){this.panel.style.top='auto';this.panel.style.bottom='100%';}
   const shift=Math.max(left-r.left,Math.min(0,right-r.right));this.panel.style.transform=`translateX(${shift}px)`;
  }
  async update(){
   try{
    const data=await policy();if(!this.isConnected)return;
    const cents=Number(this.dataset.cents);if(!Number.isSafeInteger(cents)||cents<0)throw new Error('price');
    const c=data.campaign;const ids=(this.dataset.collections||'').split(',');let factor=1;
    if(c&&Date.now()<Date.parse(c.endAt)&&(!c.collectionIds?.length||c.collectionIds.some(id=>ids.includes(id))))factor=c.factor;
    if(typeof factor!=='number'||factor<1||factor>3)throw new Error('factor');
    const quantity=Number(this.productInfo?.querySelector('input[name="quantity"]')?.value??1);
    if(!Number.isSafeInteger(quantity)||quantity<1||!Number.isSafeInteger(cents*quantity))throw new Error('quantity');
    const hearts=Math.floor(Math.floor(cents*quantity/100)*Math.round(factor*10)/10);this.querySelector('[data-heart-count]').textContent=String(hearts);
    this.button.setAttribute('aria-label',this.dataset.label.replace('{n}',String(hearts)));
    this.querySelector('[data-heart-message]').textContent=(data.eligible===true?this.dataset.memberText:this.dataset.guestText).replace('{n}',String(hearts));
    const promo=this.querySelector('[data-heart-promo]');promo.hidden=factor===1;promo.textContent=this.dataset.promoText.replace('{factor}',factor.toLocaleString('de-DE'));
    const badge=this.querySelector('[data-heart-factor]');badge.hidden=factor===1;badge.textContent=factor.toLocaleString('de-DE')+'×';
    this.classList.toggle('cosy-product-hearts--bonus',factor>1);
    if(factor>1)this.button.setAttribute('aria-label',this.button.getAttribute('aria-label')+'. '+promo.textContent);
    this.hidden=false;if(this.panel&&!this.panel.hidden)this.open(true);
   }catch{this.hidden=true;}
  }
 }
 customElements.define('cosy-product-hearts',CosyProductHearts);
})();
